
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



  const cardData =
  {
    keyword: 'Mini Bus on Rent in Pune',
    heading: 'AB Ghule Cabs: Mini Bus on Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers reliable, comfortable, and affordable mini bus rental services in Pune. Whether you are planning a family outing, corporate event, or group trip, our well-maintained mini buses are perfect for local travel, long-distance journeys, or sightseeing tours. With spacious interiors, modern amenities, and experienced drivers, we ensure a hassle-free and enjoyable journey for your entire group.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Mini Bus Rental in Pune',

 "topPlaces": [
  {
    title: "Spacious and Comfortable",
    description: "Our mini buses are designed with comfort in mind, featuring spacious seating, ample legroom, and modern air-conditioning systems to ensure a comfortable journey for all passengers. Whether you're traveling short distances within Pune or heading on a longer trip, you'll enjoy a smooth and relaxing ride. With comfortable interiors and thoughtful design, our mini buses offer the ideal space for groups to relax and unwind during their journey."
  },
  {
    title: "Affordable Pricing",
    description: "At AB Ghule Cabs, we offer competitive and budget-friendly rates for both short-term and long-term rentals. Whether you need a mini bus for a day trip within Pune or a week-long tour of nearby destinations, our transparent pricing ensures you get the best value for your money. We understand the importance of keeping costs manageable, and our rental prices are designed to suit a variety of budgets, making group travel affordable for everyone."
  },
  {
    title: "Experienced Drivers",
    description: "Our team of professional drivers is highly trained to navigate through Pune’s busy streets and rural roads with ease, ensuring a smooth and safe journey. With years of experience behind the wheel, they are well-versed in the city's roads and traffic conditions. Additionally, our drivers are familiar with popular tourist spots and local landmarks, offering helpful recommendations and guiding you during sightseeing trips, ensuring you make the most out of your journey."
  },
  {
    title: "Wide Range of Vehicles",
    description: "No matter the size of your group, we have the perfect mini bus to meet your needs. Choose from our fleet of 18-seater, 24-seater, and 32-seater mini buses, each offering ample space and comfort for your group. Whether you're traveling with a small family, a large corporate group, or a school tour, we can accommodate your specific requirements and ensure that every passenger travels comfortably and safely."
  },
  {
    title: "24/7 Availability",
    description: "We understand that travel plans can sometimes require flexibility, which is why our mini bus rental services are available around the clock. Whether you need to arrange a late-night airport transfer, an early morning tour, or a last-minute trip, we’re here to provide reliable and prompt services at any time of the day or night. Our commitment to availability ensures that your travel plans are never hindered by time constraints."
  },
  {
    title: "Customizable Packages",
    description: "AB Ghule Cabs offers a wide range of customizable packages to suit the specific needs of your group. Whether you're planning a family outing, a corporate event, a sightseeing tour, or a group airport transfer, our team can help you design the perfect package. Choose your preferred duration, destinations, and services, and we’ll tailor the trip to ensure it meets your exact requirements, giving you flexibility and control over your travel experience."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All of our mini buses undergo regular maintenance and thorough servicing to guarantee a smooth, safe, and trouble-free ride. We prioritize cleanliness and hygiene, and every vehicle is sanitized before every trip, ensuring that you and your group travel in a pristine environment. With up-to-date safety features and a well-maintained fleet, we take pride in providing vehicles that are in excellent condition for your journey."
  },
  {
    title: "Tourist Sightseeing in Pune and Nearby Areas",
    description: "Our mini buses are the perfect option for sightseeing trips within Pune and nearby areas such as Lonavala, Mahabaleshwar, Sinhagad Fort, and more. Whether you're interested in historical landmarks, scenic spots, or popular attractions, we provide comfortable transport to ensure you have a hassle-free experience. Let our drivers guide you through Pune’s hidden gems and popular tourist spots, offering an unforgettable sightseeing tour."
  },
  {
    title: "Easy Booking Process",
    description: "Booking a mini bus with AB Ghule Cabs is simple, fast, and hassle-free. Whether you prefer to book online through our user-friendly platform or over the phone, our team is here to assist you at every step. From selecting the right vehicle to customizing your trip, we make sure the process is seamless so you can focus on enjoying your journey. Our friendly customer support team is available to address any questions and help with the booking process."
  },
  {
    title: "No Hidden Charges",
    description: "We believe in providing a straightforward and transparent pricing structure with no hidden charges. The price you see when you make your booking is the price you pay at the end of your trip. There are no surprise costs, and we make sure to provide you with clear and upfront details about the pricing. This commitment to transparency ensures that you can enjoy your rental experience with confidence and peace of mind."
  }
],


  services: [
    {
      "name": "Mini Bus Hire in Pune",
      description: "Looking for a mini bus hire in Pune? AB Ghule Cabs offers a wide range of mini buses for various occasions. Whether you need a vehicle for a family trip, corporate event, or a large group outing, our mini buses provide comfort and convenience."
    },
    {
      "name": "Mini Bus Hire Pune",
      description: "Rent a mini bus in Pune with AB Ghule Cabs. We offer reliable and affordable mini bus services for local and outstation trips. Choose from a variety of options to suit your group’s needs, including 14-seater, 25-seater, and luxury mini buses."
    },
    {
      "name": "Mini Bus Rental Pune",
      description: "AB Ghule Cabs provides mini bus rental services in Pune with a focus on customer satisfaction. Our rental options include flexible rates and multiple vehicle sizes to fit any group size. Book your mini bus rental with us for a smooth and enjoyable journey."
    },
    {
      "name": "Mini Bus Service in Pune",
      description: "AB Ghule Cabs is your go-to provider for mini bus services in Pune. Whether it's for a family reunion, school trip, or business event, our mini bus services offer safe, comfortable, and punctual travel with a focus on convenience."
    },
    {
      "name": "Mini Bus Service Pune",
      description: "Explore our mini bus services in Pune with AB Ghule Cabs for any occasion. We provide mini buses for tours, corporate events, weddings, and more. Our fleet is well-maintained and comes with experienced drivers to ensure a hassle-free experience."
    },
    {
      "name": "Pune Mini Bus Rental",
      description: "AB Ghule Cabs offers mini bus rental services in Pune, ideal for both short and long-distance trips. From luxury to budget-friendly options, we provide well-equipped mini buses for local tours, outstation trips, and corporate events."
    },
    {
      "name": "Mini Bus Booking Pune",
      description: "Booking a mini bus in Pune has never been easier with AB Ghule Cabs. You can book your mini bus online or by phone. We ensure quick and simple bookings with reliable service at affordable prices. Whether for a wedding, conference, or sightseeing, we’ve got you covered."
    },
    {
      "name": "Mini Bus in Pune",
      description: "Travel around Pune with ease in our mini buses. AB Ghule Cabs offers mini buses for hire in Pune for all types of events. Whether you’re going for a sightseeing tour, a corporate retreat, or a social gathering, our mini buses will ensure a comfortable ride."
    },
    {
      "name": "Affordable Mini Bus Pune",
      description: "Looking for an affordable mini bus in Pune? AB Ghule Cabs offers pocket-friendly mini bus hire options without compromising on comfort or service. Enjoy the best value for your money with our mini buses equipped for both short and long trips."
    },
    {
      "name": "Mini Bus Hire Pune",
      description: "Rent a mini bus for your group outing or business event in Pune with AB Ghule Cabs. Our fleet includes well-maintained mini buses of various sizes, including 14-seater and 25-seater options. Choose the right bus for your needs at competitive rental prices."
    },
    {
      "name": "Mini Bus Rental Pune",
      description: "AB Ghule Cabs offers mini bus rental services in Pune for different group sizes and occasions. Our fleet includes both standard and luxury mini buses, with options for local trips and outstation travel. Book your mini bus rental today for a convenient and enjoyable ride."
    },
    {
      "name": "Pune Mini Bus Hire",
      description: "AB Ghule Cabs provides mini bus hire in Pune for corporate events, family trips, and group travel. Our fleet is fully equipped with modern amenities, ensuring comfort for all passengers. Rent your mini bus from us today and enjoy a hassle-free journey."
    },
    {
      "name": "Luxury Mini Bus, Pune",
      description: "For those seeking extra comfort and style, AB Ghule Cabs offers luxury mini buses for hire in Pune. These buses come with plush seating, air conditioning, and all the amenities you need for a comfortable journey. Ideal for corporate events, weddings, and premium group travel."
    },
    {
      "name": "Corporate Mini Bus Pune",
      description: "Looking for a corporate mini bus in Pune? AB Ghule Cabs provides mini buses for corporate events, meetings, and team outings. Our fleet includes well-maintained vehicles, driven by professional drivers, to ensure your business trip is comfortable and efficient."
    },
    {
      "name": "Pune to Shirdi Mini Bus on Rent",
      description: "Need a mini bus for a trip from Pune to Shirdi? AB Ghule Cabs offers mini buses for rent to Shirdi. Our fleet includes various sizes, including 14-seater and 25-seater options, ideal for family and group trips to Shirdi."
    },
    {
      "name": "Pune to Mahabaleshwar Mini Bus on Rent",
      description: "Book a mini bus for your trip from Pune to Mahabaleshwar with AB Ghule Cabs. We provide affordable mini bus rentals with experienced drivers for a comfortable journey to Mahabaleshwar, one of the most popular hill stations near Pune."
    },
    {
      "name": "Pune to Mumbai Mini Bus on Rent",
      description: "If you are planning a trip from Pune to Mumbai, AB Ghule Cabs offers mini buses for rent. Our fleet of mini buses provides comfortable seating, air conditioning, and a professional driver to ensure you enjoy a smooth ride from Pune to Mumbai."
    },
    {
      "name": "Pune to Mumbai Airport Mini Bus on Rent",
      description: "Book a mini bus for your group’s airport transfer from Pune to Mumbai with AB Ghule Cabs. Whether you are heading to Mumbai for business or leisure, our mini bus rentals offer a convenient and comfortable way to travel."
    },
    {
      "name": "Mini Bus Rentals",
      description: "AB Ghule Cabs offers mini bus rentals for all kinds of trips, whether it's a corporate outing, a family tour, or a sightseeing trip. Our fleet includes a variety of mini buses to cater to different group sizes and travel requirements."
    },
    {
      "name": "Small Bus Rental",
      description: "In addition to mini buses, AB Ghule Cabs also provides small bus rentals. Ideal for smaller groups, these buses offer comfort and flexibility for local and outstation travel. Rent a small bus today for your next trip."
    },
    {
      "name": "25 Seater Minibus",
      description: "AB Ghule Cabs provides 25-seater mini buses for hire in Pune. These spacious buses are perfect for larger groups and ensure comfort during long-distance and local travel."
    },
    {
      "name": "Mini Coach Bus Rental",
      description: "For larger groups, AB Ghule Cabs offers mini coach bus rentals. Our mini coaches are well-equipped for group travel, whether for corporate events, school trips, or family outings."
    },
    {
      "name": "Pune to Goa Mini Bus on Rent",
      description: "Going to Goa from Pune? Rent a mini bus with AB Ghule Cabs for a comfortable journey. We offer competitive pricing and well-maintained buses for your trip to Goa."
    },
    {
      "name": "14 Seater Mini Bus on Rent",
      description: "Looking for a mini bus with 14-seater capacity? AB Ghule Cabs offers 14-seater mini buses for rent in Pune. Ideal for smaller group trips, these mini buses provide comfortable seating and modern amenities."
    },
    {
      "name": "Mini Bus on Hire in Pune – AB Ghule Cabs",
      description: "AB Ghule Cabs offers mini bus hire services in Pune with a range of vehicle options. Our buses are perfect for outstation travel, corporate events, family trips, and more. Rent your mini bus today for a hassle-free experience."
    },
    {
      "name": "Luxury Bus on Rent in Pune",
      description: "AB Ghule Cabs offers luxury bus rentals in Pune for those seeking a more premium travel experience. Our fleet of luxury buses provides comfort, style, and all the necessary amenities for a perfect journey."
    },
    {
      "name": "Mini Bus on Rent for Corporate Events",
      description: "For corporate events, conferences, and team outings, AB Ghule Cabs offers mini buses for rent in Pune. Our fleet includes well-maintained buses with professional drivers to ensure your corporate travel is comfortable and efficient."
    },
    {
      "name": "Mini Bus On Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mini Bus On Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Mini Bus Hire in Pune", "- Mini Bus Hire Pune"],
    ["Mini Bus Rental Pune", "- Mini Bus Service in Pune"],
    ["Mini Bus Service Pune", "- Pune Mini Bus Rental"],
    ["Mini Bus Booking Pune", "- Mini Bus in Pune"],
    ["Affordable Mini Bus Pune", "- Mini Bus Hire Pune"],
    ["Mini Bus Rental Pune", "- Pune Mini Bus Hire"],
    ["Luxury Mini Bus Pune", "- Corporate Mini Bus Pune"],
    ["Pune to Shirdi Mini Bus on Rent", "- Pune to Mahabaleshwar Mini Bus on Rent"],
    ["Pune to Mumbai Mini Bus on Rent", "- Pune to Mumbai Airport Mini Bus on Rent"],
    ["Mini Bus Rentals", "- Small Bus Rental"],
    ["25 Seater Mini Bus", "- Mini Coach Bus Rental"],
    ["Pune to Goa Mini Bus on Rent", "- 14 Seater Mini Bus on Rent"],
    ["Mini Bus on Hire in Pune AB Ghule Cabs", "- Luxury Bus on Rent in Pune"],
    ["Mini Bus on Rent for Corporate Events", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Spacious and Comfortable Ride",
      WhyChoosedescription: "Our mini buses offer ample space, ensuring that your entire group can travel comfortably. With comfortable seating, air-conditioning, and ample legroom, our mini buses are perfect for group outings, corporate events, school trips, or family gatherings."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "We prioritize safety and comfort. Our experienced, courteous, and professional drivers are well-trained to handle group travel. They are familiar with the best routes and traffic patterns, ensuring a smooth and timely journey."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our mini buses are regularly cleaned, inspected, and maintained to the highest standards. We ensure that each bus is in top condition, so you can travel with confidence, knowing that you're in safe hands."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive pricing for mini bus rentals in Pune, ensuring you get the best value for your money. Our pricing structure is transparent, with no hidden charges, so you can plan your budget with certainty."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Whether you need a mini bus for a few hours, a full day, or an extended rental, we offer flexible packages to suit your needs. Our services can be tailored for weddings, corporate events, or leisure trips."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a mini bus with AB Ghule Cabs is easy and hassle-free. You can book online via our website or app, or simply call our customer service to reserve your bus and get assistance with your booking."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guaranteed",
      WhyChoosedescription: "We have a long history of satisfied customers, and we always strive to make your experience seamless. Our customer support team is available to assist you throughout the process, from booking to drop-off."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a mini bus with AB Ghule Cabs?',
      answer: 'You can book a mini bus via our website, mobile app, or by calling our customer service team. We ensure a simple and quick booking process.',
    },
    {
      id: 'FAQ2',
      question: 'What types of mini buses are available for rent?',
      answer: 'We offer a variety of mini buses, from standard to luxury models, to cater to different group sizes and preferences. You can choose based on your needs.',
    },
    {
      id: 'FAQ3',
      question: 'Are the mini buses air-conditioned?',
      answer: 'Yes, all our mini buses are fully air-conditioned to ensure a comfortable ride, regardless of the weather.',
    },
    {
      id: 'FAQ4',
      question: 'What is the rental cost for a mini bus?',
      answer: 'The cost of renting a mini bus depends on the duration, distance, and type of vehicle. We offer affordable rates and a transparent pricing structure with no hidden charges.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers experienced and professional?',
      answer: 'Yes, all our drivers are highly experienced, well-trained, and background-checked to ensure the safety and comfort of your group.',
    },
    {
      id: 'FAQ6',
      question: 'Can I book a mini bus for a day trip or an extended journey?',
      answer: 'Yes, we offer both one-day trips and extended rental options. Our flexible packages are designed to suit your schedule and requirements.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for the mini bus rental?',
      answer: 'Payments can be made through various methods, including cash, credit/debit cards, or online payment via our app. We offer convenient payment options for your convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Is there a cancellation policy for mini bus rentals?',
      answer: 'Yes, our cancellation policy depends on the timing of your request. Please contact our customer service team for specific details.',
    },
    {
      id: 'FAQ9',
      question: 'Do you provide mini buses for corporate events or school trips?',
      answer: 'Yes, we offer customized services for corporate events, school outings, family gatherings, and more. We can tailor the mini bus rental according to your needs.',
    },
    {
      id: 'FAQ10',
      question: 'What if I need to make changes to my booking?',
      answer: 'You can modify your booking easily through our website or app. If you need assistance, our customer support team is always available to help.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Anil Patil',
      feedback: 'We rented a mini bus from AB Ghule Cabs for our family reunion, and it was a fantastic experience. The bus was spacious, clean, and comfortable. Our driver was punctual and professional, ensuring that we had a smooth and enjoyable trip. I highly recommend their services for group travel!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Rupal Deshmukh',
      feedback: 'We used AB Ghule Cabs\' mini bus service for a corporate event, and it exceeded our expectations. The bus was well-maintained, and the driver was very courteous. The ride was comfortable, and the entire group had a great experience. We will definitely consider using their services again.',
      rating: 5,
    },
  ];
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mini Bus on Rent in Pune | Affordable Mini Bus Hire & Rental Services</title>
  <meta name="description" content="Mini bus rental services in Pune. Offering affordable mini bus hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings." />
  <meta name="keywords" content="Mini Bus Hire in Pune, Mini Bus Hire Pune, Mini Bus Rental Pune, Mini bus service in Pune, Mini bus service Pune, Pune mini bus rental, Mini bus booking Pune, Mini bus in Pune, Affordable mini bus Pune, Mini bus hire Pune, Mini bus rental Pune, Pune mini bus hire, Luxury mini bus Pune, Corporate mini bus Pune, Pune to Shirdi Mini bus on rent, Pune to Mahabaleshwar mini bus on rent, Pune to Mumbai mini bus on rent, Pune to Mumbai airport mini bus on rent, Mini bus rentals, Small bus rental, 25 seater Minibus, Mini Coach Bus Rental, Pune to Goa mini Bus on Rent, 14 seater mini bus on rent, Mini Bus On Hire in Pune AB Ghule Cabs, Luxury bus on rent in Pune, Mini bus on rent for corporate events" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mini Bus on Rent in Pune | Affordable Mini Bus Hire & Rental Services" />
  <meta property="og:description" content="Mini bus rental services in Pune. Offering affordable mini bus hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/mini-bus-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mini-bus-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Mini Bus on Rent in Pune",
        description: "Mini bus rental services in Pune. Offering affordable mini bus hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mini-bus-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/mini-bus-rent.jpg",
        "image": "https://abghulecabs.com/images/mini-bus-rent.jpg",
        "priceRange": "₹5000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mini-bus-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "110"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suresh T"
            },
            "datePublished": "2024-11-18",
            "reviewBody": "The mini bus service was excellent. We hired it for our corporate event, and the bus was clean, spacious, and the driver was professional. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Aarti P"
            },
            "datePublished": "2024-10-22",
            "reviewBody": "We took the mini bus to Mahabaleshwar. It was a comfortable ride, and the service from AB Ghule Cabs was fantastic. Thank you for making our trip enjoyable!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Mini Bus Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mini-bus-on-rent-in-pune"
        },
        "keywords": "Mini Bus Hire in Pune, Mini Bus Hire Pune, Mini Bus Rental Pune, Mini bus service in Pune, Mini bus service Pune, Pune mini bus rental, Mini bus booking Pune, Mini bus in Pune, Affordable mini bus Pune, Mini bus hire Pune, Mini bus rental Pune, Pune mini bus hire, Luxury mini bus Pune, Corporate mini bus Pune, Pune to Shirdi Mini bus on rent, Pune to Mahabaleshwar mini bus on rent, Pune to Mumbai mini bus on rent, Pune to Mumbai airport mini bus on rent, Mini bus rentals, Small bus rental, 25 seater Minibus, Mini Coach Bus Rental, Pune to Goa mini Bus on Rent, 14 seater mini bus on rent, Mini Bus On Hire in Pune AB Ghule Cabs, Luxury bus on rent in Pune, Mini bus on rent for corporate events"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/46.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Minibusonrentinpune;